package org.example.project.engineletter

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.window
import org.example.project.service.LocalScreenInternalTitleVisible
import org.example.project.cleaning.SharedWorkspaceStyle
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexGrow
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.minHeight
import org.jetbrains.compose.web.css.paddingBottom
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Style
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.events.Event
import kotlin.math.min

@Composable
fun LetterEngineLayout(
    title: String,
    showTitle: Boolean = true,
    scaleToPage: Boolean = true,
    buttonBar: @Composable () -> Unit,
    content: @Composable () -> Unit
) {
    val internalTitleVisible = LocalScreenInternalTitleVisible.current
    val pageWidthPx = 794.0
    val pageHeightPx = 1123.0
    val viewportPaddingPx = 64.0
    val reservedChromeHeightPx = 310.0

    var viewportWidth by remember { mutableStateOf(window.innerWidth.toDouble()) }
    var viewportHeight by remember { mutableStateOf(window.innerHeight.toDouble()) }

    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = {
            viewportWidth = window.innerWidth.toDouble()
            viewportHeight = window.innerHeight.toDouble()
        }
        window.addEventListener("resize", listener)
        onDispose { window.removeEventListener("resize", listener) }
    }

    val availableWidth = (viewportWidth - viewportPaddingPx).coerceAtLeast(320.0)
    val availableHeight = (viewportHeight - reservedChromeHeightPx).coerceAtLeast(320.0)
    val pageScale = min(1.0, min(availableWidth / pageWidthPx, availableHeight / pageHeightPx))

    Style(cssRules = SharedWorkspaceStyle.cssRules)
    Div({ classes(SharedWorkspaceStyle.workspace) }) {
        Div({ classes(SharedWorkspaceStyle.side, SharedWorkspaceStyle.content); style { width(100.percent) } }) {
            Div({
                classes(SharedWorkspaceStyle.contentInner)
                style {
                    maxWidth(100.percent)
                    flexGrow(1)
                    minHeight(0.px)
                    property("overflow", "hidden")
                }
            }) {
                if (showTitle && internalTitleVisible) {
                    Div({ classes(SharedWorkspaceStyle.rightTitle) }) {
                        Span({ classes(SharedWorkspaceStyle.sectionTitle) }) { Text(title) }
                    }
                }
                buttonBar()
                Div({
                    style {
                        display(DisplayStyle.Flex)
                        justifyContent(JustifyContent.Center)
                        width(100.percent)
                        height(availableHeight.px)
                        paddingBottom(40.px)
                        property("overflow", "hidden")
                        property("align-items", "flex-start")
                    }
                }) {
                    if (scaleToPage) {
                        Div({ style { width((pageWidthPx * pageScale).px); height((pageHeightPx * pageScale).px); property("overflow", "hidden") } }) {
                            Div({ style { width(pageWidthPx.px); property("transform", "scale($pageScale)"); property("transform-origin", "top left") } }) { content() }
                        }
                    } else {
                        Div({ style { width(100.percent); height(100.percent); property("overflow-y", "auto") } }) { content() }
                    }
                }
            }
        }
    }
}
